/* DSL Cart abandonment ML-style trigger — score idle-time + scroll-up + tab-blur */
(function(){
  if (location.pathname !== "/cart") return;
  var idle = 0, exitSignal = 0;
  var lastY = window.scrollY;
  var lastActive = Date.now();
  document.addEventListener("mousemove", function(){ idle = 0; lastActive = Date.now(); });
  document.addEventListener("scroll", function(){
    if (window.scrollY < lastY - 50) exitSignal++;
    lastY = window.scrollY;
  });
  setInterval(function(){
    var s = (Date.now() - lastActive) / 1000;
    if (s > 30) idle++;
    if (idle >= 2 && exitSignal >= 2) {
      if (window.DSL_BANNER) window.DSL_BANNER.show({text: "💡 Tip: voer code <strong>SAVE5</strong> in voor €5 korting.", variant: "info", duration: 8000});
      if (window.DSL_AB) window.DSL_AB.track("abandonment_trigger", {idle: idle, exitSignal: exitSignal});
      idle = 0; exitSignal = 0; // reset
    }
  }, 5000);
})();